import { Component, inject, OnInit } from '@angular/core';
import { HomeContentStore } from '../store/home-content.store';

@Component({
  selector: 'app-shortcuts',
  imports: [],
  templateUrl: './shortcuts.html',
  styleUrl: './shortcuts.scss',
})
export class Shortcuts implements OnInit {
    protected readonly homeContentStore = inject(HomeContentStore);

    public ngOnInit(): void {
        void this.homeContentStore.ensureLoaded();
    }
}
